import React from 'react';
import styled from 'styled-components/macro';
import ErrorIcon from '@mui/icons-material/Error';

import ScheduleAppointmentModal from 'components/general/SchduleAppointmentModal';
import logo from '../../../../assets/images/logo-ghs.svg';
import { error } from 'variables/colors';
import { FlexCenter } from 'styles/flexbox';

const Content = styled(FlexCenter)`
  height: 100vh;
  min-height: 24em;
  padding: 1.5em;
  text-align: center;

  .MuiSvgIcon-root {
    margin-bottom: 0.5em;
    color: ${error};
  }

  @media (min-width: 30em) {
    height: 100%;
  }
`;

const Heading = styled.h2`
  margin-bottom: 1.5em;
  line-height: 1.5;
`;

const Description = styled.p``;

const Logo = styled.img`
  width: 4em;
  margin-bottom: 1.5em;
`;

const Confirmation = ({ heading, description, isError }) => (
  <ScheduleAppointmentModal empty fullHeight>
    <Content>
      <div>
        {isError ? <ErrorIcon fontSize="large" /> : <Logo src={logo} />}
        <Heading>{heading}</Heading>
        <Description>{description}</Description>
      </div>
    </Content>
  </ScheduleAppointmentModal>
);

export default Confirmation;
